const resource = '/admin/v1/editor'

export default $axios => ({
  store(payload) {
    return $axios.post(`${resource}/uploadImage`, payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },
})
